import Main from '@/views/main.vue'

import {orderlistMenuRouter} from './orderlist'

const orderMenuRouter = {
  has: 'orderStatistics',
  path: '/',
  icon: 'android-people',
  name: 'orderMenuRouter',
  title: '工单统计',
  component: Main,
  children: [
    ...orderlistMenuRouter
  ]
}

export {orderMenuRouter}



// WEBPACK FOOTER //
// ./src/router/order/index.js